<template lang='pug'>
  v-responsive.pa-0(fluid )  
    v-app
      v-snackbar( v-model="Ayudas.mostrar_snackbar" :timeout='3000') 
        span {{ Ayudas.mensaje_de_snackbar }}
        v-btn( color='naranja' text @click='Ayudas.mostrar_snackbar=false' ) Cerrar
      v-overlay( v-model='cargando' opacity='1' color='#2A103F')
        img( :src='logitomovible' height='100px')          
      router-view
</template>
<script>
import { mapActions, mapState } from 'vuex'
import logitomovible from './assets/cargandogif/logitomovible.gif'
export default {
  data(){
    return{
      cargando: true,
      logitomovible,
    }

  },
  created(){
    this.obtener_datos()
    this.obtener_entradas()
    this.obtener_etiquetas()
  },
  watch:{
    Contenido(){
      this.cargando= false
    }
  },
  computed:{
    ...mapState({
      Ayudas : ({Ayudas}) => Ayudas,
    }),
  },
  methods: {
    ...mapActions({
      obtener_datos: 'Landing_set/obtener',
      obtener_entradas: 'Blog/obtener_todos',
      obtener_etiquetas: 'Etiquetas/obtener_todos',
    }),
  },
}
</script>
<style lang="sass">
@font-face 
  font-family: 'TitilliumWeb'
  src: url("./assets/fonts/TitilliumWeb-ExtraLight.ttf") format("truetype")
  font-weight: 100

@font-face 
  font-family: 'TitilliumWeb'
  src: url("./assets/fonts/TitilliumWeb-Light.ttf") format("truetype")
  font-weight: 200
@font-face 
  font-family: 'Raleway'
  src: url("./assets/fonts/Raleway-VariableFont_wght.ttf") format("truetype")
  font-weight:  800
@font-face 
  font-family: 'Averta'
  src: url("./assets/fonts/Averta-Extra-Bold.otf") format("opentype")
  font-weight:  900
@font-face 
  font-family: 'Averta-Cyrillic'
  src: url("./assets/fonts/Averta-Cyrillic-ExtraBold.otf") format("opentype")
  font-weight:  900



h1,h2,h3,h4,h5,h6,.display-1, .display-2, .display-3, .display-4, .title
  font-family: 'Averta'
p, span, a, button, input, textarea, label
  font-family: 'TitilliumWeb', 
:root 
  --primary: #F3A831
  --secondary: #2A103F

</style>